import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SocialHeartIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialHeart",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M23.33 4.09C18.37 4.09 16 9.51 16 9.51s-2.37-5.42-7.34-5.42S2 8.94 2 11.43c0 4.96 4.74 11.85 14 16.47 9.26-4.62 14-11.51 14-16.47 0-2.49-1.7-7.34-6.67-7.34"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.86 29.29c-.19 0-.37-.05-.54-.14-.64-.34-15.46-8.44-15.46-18.72 0-4.73 3.84-8.57 8.57-8.57S17 5.71 17 10.43a1.14 1.14 0 1 1-2.28 0c0-3.47-2.82-6.29-6.29-6.29s-6.29 2.82-6.29 6.29c0 7.91 11.11 14.87 13.71 16.4 2.61-1.53 13.71-8.49 13.71-16.4 0-3.47-2.82-6.29-6.29-6.29-1.19 0-2.35.33-3.35.97-.53.34-1.24.18-1.58-.36-.34-.53-.18-1.24.36-1.58a8.56 8.56 0 0 1 4.57-1.32c4.73 0 8.57 3.85 8.57 8.57 0 10.28-14.83 18.38-15.46 18.72-.17.09-.36.14-.54.14Z"
      })
    })
  }));
};
SocialHeartIcon.displayName = 'SocialHeartIcon';